import { render, staticRenderFns } from "./PrintTemplates.vue?vue&type=template&id=4b061d92&"
import script from "./PrintTemplates.vue?vue&type=script&lang=js&"
export * from "./PrintTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports